import React from 'react';
import { UtensilsCrossed, Fish, Pizza, Leaf } from 'lucide-react';
import ResponsiveImage from '../ResponsiveImage';

const AboutSection = () => {
  const features = [
    {
      icon: Pizza,
      title: 'Stone-Baked Pizza',
      description: 'Crafted with love and baked to perfection in our traditional stone oven.'
    },
    {
      icon: Fish,
      title: 'Fresh Seafood',
      description: 'Sourced from the finest suppliers to ensure every bite is a taste of the ocean.'
    },
    {
      icon: UtensilsCrossed,
      title: 'Homemade Pasta',
      description: 'Traditional recipes with homemade sauces and generous toppings.'
    },
    {
      icon: Leaf,
      title: 'Fresh Ingredients',
      description: 'Only the finest and freshest ingredients in all our dishes.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="image-hover rounded-2xl overflow-hidden shadow-xl bg-[#F5EFE7]">
              <ResponsiveImage
                basePath="/images/about"
                alt="La Pasteria Restaurant Interior"
                sizes="(max-width: 768px) 100vw, 600px"
                className="w-full h-[500px] object-cover"
              />
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-8 bg-[#1B4332] rounded-2xl p-6 shadow-xl max-w-xs hidden lg:block">
              <p className="font-serif text-2xl font-bold text-white mb-2">Family Restaurant</p>
              <p className="text-white/80">
                A gathering spot for food lovers, families, and friends.
              </p>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="inline-block text-sm font-semibold tracking-wider text-[#C67C4E] uppercase mb-4">
              Our Story
            </span>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1B4332] mb-6">
              Welcome To La Pasteria Pizza Bar
            </h2>
            <p className="text-lg text-[#636E72] mb-6 leading-relaxed">
              Welcome to our newly opened restaurant, La Pasteria Pizza Bar, High Street North, 
              Dunstable. Where we bring you a delightful culinary experience that celebrates 
              the flavours of the sea, the warmth of stone-baked pizza, and the comforting 
              goodness of pasta.
            </p>
            <p className="text-lg text-[#636E72] mb-8 leading-relaxed">
              Indulge in our fresh and succulent seafood dishes, savour the crispy perfection 
              of our stone-baked pizzas, and dive into a bowl of comforting pasta. Our family 
              restaurant is not just a place to eat; it&apos;s a gathering spot for food lovers.
            </p>
            <p className="font-serif text-2xl italic text-[#C67C4E]">
              Grazie!
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-24">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="bg-[#F5F0E8] rounded-2xl p-8 text-center hover-lift"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 bg-[#1B4332] rounded-full flex items-center justify-center mx-auto mb-6">
                <feature.icon size={28} className="text-white" />
              </div>
              <h3 className="font-semibold text-xl text-[#1B4332] mb-3">
                {feature.title}
              </h3>
              <p className="text-[#636E72]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
